module.exports = __webpack_public_path__ + "static/media/warning.6d1bac02.svg";